"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAxiosError = void 0;
const typescriptExtensions_1 = require("../types/typescriptExtensions");
// Implementation from Axios.isAxiosError v0.29.2, which is not available in OCM's version 0.17.x
function isAxiosError(payload) {
    return ((0, typescriptExtensions_1.isNonNullObject)(payload) && (0, typescriptExtensions_1.hasProp)(payload, 'isAxiosError') && payload.isAxiosError === true);
}
exports.isAxiosError = isAxiosError;
//# sourceMappingURL=axiosExtensions.js.map